import dayjs from 'dayjs';

export const formatDateTime = (
    dateTimeStr,
    format = 'HH:mm:ss - DD/MM/YYYY'
) => {
    const dayObj = dayjs(dateTimeStr);
    return dayObj.format(format);
};

export const loadScript = (tenantUri) => {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.src = `${tenantUri}/resources/assets/external/requirejs/require.js`;
        document.head.appendChild(script);

        script.onload = () => {
            resolve();
        };
        script.onerror = (err) => {
            console.error('script error', err);
            reject();
        };
    });
};

export const loadCss = async (tenantUri) => {
    return new Promise((resolve, reject) => {
        let link = document.createElement('link');
        link.href = `${tenantUri}/resources/autogenerated/qlik-styles.css`;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        document.head.appendChild(link);

        link.onload = () => {
            resolve();
        };

        link.onerror = (err) => {
            console.error('Stylesheet failed to load', err);
            reject();
        };
    });
};
